import * as React from 'react';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import { observer } from 'mobx-react-lite';
import { PersonaSize } from '@fluentui/react/lib/Persona';
import {
    useLivePersonaCard,
    PersonaCardBehaviorProps,
} from 'owa-persona/lib/components/PersonaCardBehavior';

export interface RelatedContentSenderProps extends PersonaCardBehaviorProps {
    name: string;
    emailAddress: string;
    size: PersonaSize;
    className?: string;
}

export default observer(function RelatedContentSender(props: RelatedContentSenderProps) {
    const PersonaCardBehavior = useLivePersonaCard(props);

    return (
        <PersonaCardBehavior>
            <PersonaControl
                name={props.name}
                emailAddress={props.emailAddress}
                size={props.size}
                className={props.className}
                mailboxType={props.mailBoxType}
            />
        </PersonaCardBehavior>
    );
});
